import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faBullhorn } from "@fortawesome/free-solid-svg-icons"

export const Bullhorn = (props) => {
  return <FontAwesomeIcon faIcon={faBullhorn} {...props} />
}
